import React, { useEffect, useState } from "react";
import "./Slider.css"
import { MdKeyboardArrowLeft,MdKeyboardArrowRight } from "react-icons/md"
import axios from "axios";

const Slider2 = ({props}) => {
    const [data, setData] = useState([])


    useEffect(()=>{
        axios.get("https://create-second-app.herokuapp.com/slide2")
        .then((res) => {setData(res.data)});
    },[])
    console.log(data)
   

    const slideLeft = () =>{
       var slider = document.getElementById("slider");
       slider.scrollLeft = slider.scrollLeft + 400;
    }

    const slideRight = () =>{
        var slider = document.getElementById("slider");
        slider.scrollLeft = slider.scrollLeft - 400;
     }

    return(
        <div className="main_slider_container">
            <MdKeyboardArrowLeft size={40} className="slider_icon_left" onClick={slideLeft} />
            <div id="slider">
             {data.map((slide, index)=> {
                return(
                    <div className="slider_card">
                        <img src={slide.image} alt="image" />
                        <h2>{slide.item_name}</h2>
                        <h3>{slide.title}</h3>
                        <h3>{slide.price}</h3>
                    </div>
                )
            })}

            </div>
            <MdKeyboardArrowRight size={40} className="slider_icon_right" onClick={slideRight} />
        
        </div>
    )
}

export default Slider2;